import { render, staticRenderFns } from "./PurchaseTicketsButton.vue?vue&type=template&id=f54b822a"
import script from "./PurchaseTicketsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseTicketsButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports